module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO32PresupuestoMensualGastosFijos.2612c83.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO32PresupuestoMensualGastosFijos.mp4
// module id = 758
// module chunks = 1